<template>
  <div>
    <v-card class="card--shadow">
      <v-card-title class="purple accent-4">
        <div class="subtitle-1 white--text text-uppercase">
          Presumptive Edit Form
        </div>
      </v-card-title>
      <v-card-text>
        <!-- PATIENT INFO SECTION -->
        <v-row>
          <v-col lg="4">
            <label>No</label>
            <v-text-field
              v-model.trim="presumptiveData.serial"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col lg="4">
            <label>Name</label>
            <v-text-field
              v-model.trim="presumptiveData.name"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Presumptive Township</label>
            <v-select
              :items="townships"
              v-model="supportingTownship"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col lg="4">
            <label>Age</label>
            <v-text-field
              v-model.trim="presumptiveData.age"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Referral From</label>
            <v-select
              :items="referralFromOpt"
              v-model="referralFrom"
              item-text="name"
              item-value="id"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="4">
            <label>Sex</label>
            <v-radio-group v-model="presumptiveData.sex" row>
              <v-radio label="Male" value="1"></v-radio>
              <v-radio label="Female" value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="3">
            <label>Case Found At</label>
            <v-select
              v-model="presumptiveData.case_found_at"
              :items="caseFoundatOpt"
              item-text="name"
              item-value="id"
              dense
              outlined
              :disabled="true"
            ></v-select>
          </v-col>

          <template
            v-if="
              presumptiveData.case_found_at == 2 ||
              presumptiveData.case_found_at == 3 ||
              presumptiveData.case_found_at == 5
            "
          >
            <v-col lg="2">
              <label v-if="presumptiveData.case_found_at == 5"
                >MDRTB Reg Code</label
              >
              <label v-else>Index Case Code</label>
              <v-text-field
                v-model="presumptiveData.index_case_no"
                outlined
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col lg="2">
              <label v-if="presumptiveData.case_found_at == 5"
                >MDRTB Reg Year</label
              >
              <label v-else>Index Case Year</label>
              <v-text-field
                v-model="presumptiveData.index_case_year"
                outlined
                dense
                type="number"
              ></v-text-field>
            </v-col>
            <v-col lg="2">
              <label v-if="presumptiveData.case_found_at == 5"
                >MDRTB Reg Initial</label
              >
              <label v-else>Index Case Initial</label>
              <v-select
                v-model="presumptiveData.index_case_initial"
                :items="InitialOpt"
                item-text="text"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col lg="2">
              <label>Mono-Poly</label>
              <v-select
                v-model="presumptiveData.index_case_monopoly"
                :items="monopoly"
                item-text="text"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col
              lg="3"
              v-show="
                presumptiveData.case_found_at == 2 ||
                presumptiveData.case_found_at == 3
              "
            >
              <label>Type of DRTB Contact</label>
              <v-select
                v-model="presumptiveData.relationship"
                :items="relationOpt"
                item-text="text"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-btn @click="submitForm" class="form-btn">
          <v-icon>mdi-chevron-right-circle-outline</v-icon>Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import loaderObj from "@/components/notification/service/loader.js";

export default {
  props: {
    presumptiveData: {
      type: Object,
      default: () => {
        return {
          no: null,
          name: null,
          age: null,
          sex: null,
          case_found_at: null,
          index_case_no: null,
          index_case_year: null,
          index_case_initial: null,
          index_case_monopoly: null,
          referral_from_id:null,
          supporting_township: null,
        };
      },
    },
  },
  computed: {
    ...mapGetters("BasicData", ["caseFoundatOpt","referralFromOpt"]),
    ...mapState("BasicData", ["InitialOpt", "relationOpt",]),
    ...mapState("InfoData", ["monopoly"]),
    ...mapState("Township", ["townships"]),
    supportingTownship: {
      get() {
        return Number(this.presumptiveData.supporting_township);
      },
      set(value) {
        this.presumptiveData.supporting_township = Number(value);
      }
    },
    referralFrom: {
      get() {
        return Number(this.presumptiveData.referral_from_id);
      },
      set(value) {
        this.presumptiveData.referral_from_id = Number(value);
      }
    },
  },
  created() {
    this.$store.dispatch("BasicData/getBasicData");
    this.$store.dispatch("Township/getAllTownships");
  },
  methods: {
    validate() {
      let message = "";
      if (this.presumptiveData.name.length == 0)
        message += "Name is required\n";
      if (this.presumptiveData.age.length == 0) message += "Age is required\n";
      if (this.presumptiveData.sex.length == 0) message += "Sex is required\n";
      if (!this.presumptiveData.serial)
        message += "No is required\n";
      if (message.length > 0) {
        this.$toast.error(message, {
          timeout: 2000,
        });
      }

      return message.length > 0 ? false : true;
    },
    submitForm() {
      if (this.validate()) {

        let data = {
          id: this.$route.params.id,
          name: this.presumptiveData.name,
          age: this.presumptiveData.age,
          sex: this.presumptiveData.sex,
          no: this.presumptiveData.serial,
          case_found_at: this.presumptiveData.case_found_at,
          index_case_no: this.presumptiveData.index_case_no,
          index_case_year: this.presumptiveData.index_case_year,
          index_case_initial: this.presumptiveData.index_case_initial,
          index_case_monopoly: this.presumptiveData.index_case_monopoly,
          township_id:this.presumptiveData.township_id,
          referral_from_id:  this.presumptiveData.referral_from_id,
          relationship: this.presumptiveData.relationship,
          supporting_township: this.presumptiveData.supporting_township
        };
        let loader = this.$loading.show(loaderObj);
        this.$store
          .dispatch("Presumptive/editInfo", data).then(() => {
            loader.hide()
          })
          
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  margin: 20px 0px !important;
}
</style>
